export default "__VITE_ASSET__BUp7FHGv__"